import { queryUser } from '../graphql-client.js';
import type { DataSearchResult } from './types.js';

const UNIVERSAL_SEARCH_QUERY = /* GraphQL */ `
  query UniversalSearch($query: String) {
    search(terms: $query) {
      results {
        __typename
        _id
        _shapeId
        searchSummary
      }
    }
  }
`;

export type SearchQueryArgs = {
  query?: string;
};

export type SearchQueryResponse = {
  search: {
    results: DataSearchResult[];
  };
};

export async function searchQuery(args: SearchQueryArgs): Promise<SearchQueryResponse> {
  return queryUser<SearchQueryResponse>(UNIVERSAL_SEARCH_QUERY)(args);
}
